// ============================================================
// THE TABLE'S DISPLAY DEFAULTS, readable from any hook (plan body-map, C2).
//
// The GM may default some of a viewer's settings for the whole table (a
// house rule per row, engine/settings/registry `tableDefault`); a viewer's
// own stored choice always wins, the table's only stands in when they have
// none. Most readers get the defaults handed down; a few - the motion every
// animated component asks about - are read too widely to thread a prop
// through, so the shell publishes them here once and those hooks subscribe.
//
// The snapshot is replaced only when it changes (React compares snapshots by
// identity: a fresh object per read would loop).
// ============================================================

let current = {};
const listeners = new Set();

export const getTableDefaults = () => current;

export function subscribeTableDefaults(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Publish the table's defaults (the shell, from the house rules). */
export function setTableDefaults(next) {
  if (JSON.stringify(next) === JSON.stringify(current)) return;
  current = next;
  listeners.forEach((l) => l());
}
